import { UseAxiosResult } from "axios-hooks";
import apiConfig from "../infrastructure/http/apiConfig";
import { UseAxiosActionResult, useAxiosGet, useAxiosPost, useAxiosPut } from "../infrastructure/http/axios";
import { apimName } from "./common";
import { schedule, criteria, run, inventoryResponse, inventoryUpsertRequest } from "./Models/types";

const schedulesAndCriteriasUri = `${apiConfig.apimUrl}${apimName}/Schedules/Criterias`;
const schedulesUri = `${apiConfig.apimUrl}${apimName}/Schedules`;
const criteriasUri = `${apiConfig.apimUrl}${apimName}/Criterias`;
const runsUri = `${apiConfig.apimUrl}${apimName}/Runs`;
const inventoryUri = `${apiConfig.apimUrl}${apimName}/Inventory/Details`;
const inventoryBatchUri = `${apiConfig.apimUrl}${apimName}/Inventory/Batch`;

export function useGetSchedules(): UseAxiosResult<Array<schedule>, any> {
	return useAxiosGet<Array<schedule>>(schedulesAndCriteriasUri, false);
}

export function useGetCriterias(): UseAxiosResult<Array<criteria>, any> {
	return useAxiosGet<Array<criteria>>(criteriasUri, false);
}

export function useGetRuns(scheduleId: string): UseAxiosResult<Array<run>, any> {
	const uri = `${runsUri}?scheduleId=${scheduleId}`
	return useAxiosGet<Array<run>>(uri, false);
}

export function usePostSchedules(): UseAxiosActionResult<schedule, any, any> {
	return useAxiosPost<schedule>(schedulesUri);
}

export function usePostCriterias(): UseAxiosActionResult<criteria, any, any> {
	return useAxiosPost<criteria>(criteriasUri);
}

export function usePutSchedules(): UseAxiosActionResult<schedule, any, any> {
	return useAxiosPut<schedule>(schedulesUri);
}

export function usePutCriterias(): UseAxiosActionResult<criteria, any, any> {
	return useAxiosPut<criteria>(criteriasUri);
}

export function useGetInventory(criteriaId: string, locationIds: string[]): UseAxiosResult<inventoryResponse[], any> {
	const locationsUri = locationIds.map(location => `locationIds=${encodeURIComponent(location)}`).join('&');
	const uri = `${inventoryUri}?criteriaId=${criteriaId}&${locationsUri}`
	return useAxiosGet<inventoryResponse[]>(uri);
}

export function useUpdateInventory(): UseAxiosActionResult<inventoryUpsertRequest, any, any> {
	return useAxiosPut<inventoryUpsertRequest>(inventoryBatchUri);
}

export function useBatchUpdateInventory(): UseAxiosActionResult<inventoryUpsertRequest[], any, any> {
	return useAxiosPost<inventoryUpsertRequest[]>(inventoryBatchUri);
}
